import { useMemo } from "react"
import { useEmojiContext } from "stream-chat-react"

type Emoji = Record<string, unknown>

export const useEmojis = (names: string[]): Emoji[] => {
  const { emojiConfig, EmojiIndex } = useEmojiContext()

  return useMemo(() => {
    const emojiIndex = new EmojiIndex(emojiConfig.emojiData)

    return names.reduce((acc: Emoji[], name) => {
      const emoji = emojiIndex.emojis[name]

      if (!emoji) {
        console.warn(`emoji for name "${name}" was not found`)
        return acc
      }

      return [...acc, emoji]
    }, [])
  }, [names, EmojiIndex, emojiConfig.emojiData])
}
